/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime'
import type {
  CreateMetricRequest,
  CreateMetricResponse,
  GetMetricListResponse,
  UpdateMetricRequest,
  UpdateMetricResponse,
} from '../models/index'

export interface CreateTableMetricRequest {
  datasetId: string
  tableId: string
  createMetricRequest: CreateMetricRequest
}

export interface DeleteTableMetricRequest {
  datasetId: string
  tableId: string
  metricId: string
  force: boolean
}

export interface GetTableMetricListRequest {
  datasetId: string
  tableId: string
}

export interface UpdateTableMetricRequest {
  datasetId: string
  tableId: string
  metricId: string
  force: boolean
  updateMetricRequest: UpdateMetricRequest
}

/**
 * 
 */
export class DatasetTablesMetricsControllerApi extends runtime.BaseAPI {
  /**
   */
  async createTableMetricRaw(
    requestParameters: CreateTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateMetricResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling createTableMetric().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling createTab,leMetric).',
      )
    }

    if (requestParameters['createMetricRequest'] == null) {
      throw new runtime.RequiredError(
        'createMetricRequest',
        'Required parameter "createMetricRequest" was null or undefined when calling createTableMetric().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/metric`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId']))),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['createMetricRequest'],
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async createTableMetric(
    requestParameters: CreateTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateMetricResponse> {
    const response = await this.createTableMetricRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async deleteTableMetricRaw(
    requestParameters: DeleteTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling deleteTableMetric().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling deleteTableMetric().',
      )
    }

    if (requestParameters['metricId'] == null) {
      throw new runtime.RequiredError(
        'metricId',
        'Required parameter "metricId" was null or undefined when calling deleteTableMetric().',
      )
    }

    if (requestParameters['force'] == null) {
      throw new runtime.RequiredError(
        'force',
        'Required parameter "force" was null or undefined when calling deleteTableMetric().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['force'] != null) {
      queryParameters['force'] = requestParameters['force']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/metric{metricId}`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId'])))
          .replace(`{${'metricId'}}`, encodeURIComponent(String(requestParameters['metricId']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse<any>(response)
  }

  /**
   */
  async deleteTableMetric(
    requestParameters: DeleteTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteTableMetricRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async getTableMetricListRaw(
    requestParameters: GetTableMetricListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetMetricListResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling getTableMetricList().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling getTableMetricList().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/metric`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async getTableMetricList(
    requestParameters: GetTableMetricListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetMetricListResponse> {
    const response = await this.getTableMetricListRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async updateTableMetricRaw(
    requestParameters: UpdateTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UpdateMetricResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling updateTableMetric().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling updateTableMetric().',
      )
    }

    if (requestParameters['metricId'] == null) {
      throw new runtime.RequiredError(
        'metricId',
        'Required parameter "metricId" was null or undefined when calling updateTableMetric().',
      )
    }

    if (requestParameters['force'] == null) {
      throw new runtime.RequiredError(
        'force',
        'Required parameter "force" was null or undefined when calling updateTableMetric().',
      )
    }

    if (requestParameters['updateMetricRequest'] == null) {
      throw new runtime.RequiredError(
        'updateMetricRequest',
        'Required parameter "updateMetricRequest" was null or undefined when calling updateTableMetric().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['force'] != null) {
      queryParameters['force'] = requestParameters['force']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/metric/{metricId}`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId'])))
          .replace(`{${'metricId'}}`, encodeURIComponent(String(requestParameters['metricId']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['updateMetricRequest'],
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async updateTableMetric(
    requestParameters: UpdateTableMetricRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UpdateMetricResponse> {
    const response = await this.updateTableMetricRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
